import { render } from "./PinButton.vue?vue&type=template&id=0c791afa"
import script from "./PinButton.vue?vue&type=script&lang=js"
export * from "./PinButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__